export const allFonts = [
"Anton", 
"Arial", 
"Barlow", 
"Bebas Neue", 
"Brush Script MT", 
"Caveat", 
"Cookie", 
"Courier New", 
"Dancing Script", 
"Francois One", 
"Fredoka One", 
"Garamond", 
"Georgia", 
"Josefin Sans", 
"Kalam", 
"Lato", 
"Lobster", 
"Luckiest Guy", 
"Merriweather", 
"Noto Sans", 
"Noto Serif TC", 
"Nunito Sans", 
"Open Sans", 
"Oswald", 
"Poiret One", 
"Roboto", 
"Satisfy", 
"Tahoma", 
"Times New Roman", 
"Trebuchet MS", 
"Verdana", 
]

// export const allFonts = [
//     [
//         "Abhaya Libre",
//         "font-abhaya-libre"
//     ],
//     [
//         "Abril Fatface",
//         "font-abril-fatface"
//     ],
//     [
//         "Abyssinica SIL",
//         "font-abyssinica-sil"
//     ],
//     [
//         "Aclonica",
//         "font-aclonica"
//     ],
//     [
//         "Acme",
//         "font-acme"
//     ],
//     [
//         "Actor",
//         "font-actor"
//     ],
//     [
//         "Adamina",
//         "font-adamina"
//     ],
//     [
//         "Adobe Blank",
//         "font-adobe-blank"
//     ],
//     [
//         "Advent Pro",
//         "font-advent-pro"
//     ],
//     [
//         "Aguafina Script",
//         "font-aguafina-script"
//     ],
//     [
//         "Akronim",
//         "font-akronim"
//     ],
//     [
//         "aksarabaligalang",
//         "font-aksarabaligalang"
//     ],
//     [
//         "Aladin",
//         "font-aladin"
//     ],
//     [
//         "Aldrich",
//         "font-aldrich"
//     ],
//     [
//         "Alef",
//         "font-alef"
//     ],
//     [
//         "alefhebrew",
//         "font-alefhebrew"
//     ],
//     [
//         "Alegreya Sans",
//         "font-alegreya-sans"
//     ],
//     [
//         "Alegreya Sans SC",
//         "font-alegreya-sans-sc"
//     ],
//     [
//         "Alegreya SC",
//         "font-alegreya-sc"
//     ],
//     [
//         "Aleo",
//         "font-aleo"
//     ],
//     [
//         "Alex Brush",
//         "font-alex-brush"
//     ],
//     [
//         "Alfa Slab One",
//         "font-alfa-slab-one"
//     ],
//     [
//         "Alice",
//         "font-alice"
//     ],
//     [
//         "Alike",
//         "font-alike"
//     ],
//     [
//         "Alike Angular",
//         "font-alike-angular"
//     ],
//     [
//         "Allan",
//         "font-allan"
//     ],
//     [
//         "Allerta",
//         "font-allerta"
//     ],
//     [
//         "Allerta Stencil",
//         "font-allerta-stencil"
//     ],
//     [
//         "Allura",
//         "font-allura"
//     ],
//     [
//         "Almendra",
//         "font-almendra"
//     ],
//     [
//         "Almendra Display",
//         "font-almendra-display"
//     ],
//     [
//         "Amarante",
//         "font-amarante"
//     ],
//     [
//         "Amatica SC",
//         "font-amatica-sc"
//     ],
//     [
//         "Amethysta",
//         "font-amethysta"
//     ],
//     [
//         "Amiko",
//         "font-amiko"
//     ],
//     [
//         "Amita",
//         "font-amita"
//     ],
//     [
//         "amstelvaralpha",
//         "font-amstelvaralpha"
//     ],
//     [
//         "Anaheim",
//         "font-anaheim"
//     ],
//     [
//         "Andada",
//         "font-andada"
//     ],
//     [
//         "Andada SC",
//         "font-andada-sc"
//     ],
//     [
//         "Andika",
//         "font-andika"
//     ],
//     [
//         "Angkor",
//         "font-angkor"
//     ],
//     [
//         "Annie Use Your Telescope",
//         "font-annie-use-your-telescope"
//     ],
//     [
//         "Anonymous Pro",
//         "font-anonymous-pro"
//     ],
//     [
//         "Antic",
//         "font-antic"
//     ],
//     [
//         "Antic Didone",
//         "font-antic-didone"
//     ],
//     [
//         "Antic Slab",
//         "font-antic-slab"
//     ],
//     [
//         "Antonio",
//         "font-antonio"
//     ],
//     [
//         "Arapey",
//         "font-arapey"
//     ],
//     [
//         "Arbutus",
//         "font-arbutus"
//     ],
//     [
//         "Arbutus Slab",
//         "font-arbutus-slab"
//     ],
//     [
//         "Architects Daughter",
//         "font-architects-daughter"
//     ],
//     [
//         "Archivo",
//         "font-archivo"
//     ],
//     [
//         "Archivo Black",
//         "font-archivo-black"
//     ],
//     [
//         "Archivo Narrow",
//         "font-archivo-narrow"
//     ],
//     [
//         "archivovfbeta",
//         "font-archivovfbeta"
//     ],
//     [
//         "Aref Ruqaa",
//         "font-aref-ruqaa"
//     ],
//     [
//         "Arimo",
//         "font-arimo"
//     ],
//     [
//         "Arizonia",
//         "font-arizonia"
//     ],
//     [
//         "Armata",
//         "font-armata"
//     ],
//     [
//         "Arsenal",
//         "font-arsenal"
//     ],
//     [
//         "Artifika",
//         "font-artifika"
//     ],
//     [
//         "Arvo",
//         "font-arvo"
//     ],
//     [
//         "Arya",
//         "font-arya"
//     ],
//     [
//         "Asap",
//         "font-asap"
//     ],
//     [
//         "Asap Condensed",
//         "font-asap-condensed"
//     ],
//     [
//         "Asar",
//         "font-asar"
//     ],
//     [
//         "Asset",
//         "font-asset"
//     ],
//     [
//         "Assistant",
//         "font-assistant"
//     ],
//     [
//         "Astloch",
//         "font-astloch"
//     ],
//     [
//         "Asul",
//         "font-asul"
//     ],
//     [
//         "Atomic Age",
//         "font-atomic-age"
//     ],
//     [
//         "Aubrey",
//         "font-aubrey"
//     ],
//     [
//         "Audiowide",
//         "font-audiowide"
//     ],
//     [
//         "Autour One",
//         "font-autour-one"
//     ],
//     [
//         "Average",
//         "font-average"
//     ],
//     [
//         "Average Sans",
//         "font-average-sans"
//     ],
//     [
//         "Averia Gruesa Libre",
//         "font-averia-gruesa-libre"
//     ],
//     [
//         "Averia Sans Libre",
//         "font-averia-sans-libre"
//     ],
//     [
//         "B612",
//         "font-b612"
//     ],
//     [
//         "B612 Mono",
//         "font-b612-mono"
//     ],
//     [
//         "Bahianita",
//         "font-bahianita"
//     ],
//     [
//         "Bai Jamjuree",
//         "font-bai-jamjuree"
//     ],
//     [
//         "Baloo",
//         "font-baloo"
//     ],
//     [
//         "Baloo Bhai",
//         "font-baloo-bhai"
//     ],
//     [
//         "Baloo Bhaijaan",
//         "font-baloo-bhaijaan"
//     ],
//     [
//         "Baloo Bhaina",
//         "font-baloo-bhaina"
//     ],
//     [
//         "Baloo Chettan",
//         "font-baloo-chettan"
//     ],
//     [
//         "Baloo Da",
//         "font-baloo-da"
//     ],
//     [
//         "Baloo Paaji",
//         "font-baloo-paaji"
//     ],
//     [
//         "Baloo Tamma",
//         "font-baloo-tamma"
//     ],
//     [
//         "Baloo Tammudu",
//         "font-baloo-tammudu"
//     ],
//     [
//         "Baloo Thambi",
//         "font-baloo-thambi"
//     ],
//     [
//         "Balthazar",
//         "font-balthazar"
//     ],
//     [
//         "Bangers",
//         "font-bangers"
//     ],
//     [
//         "Barlow",
//         "font-barlow"
//     ],
//     [
//         "Barlow Condensed",
//         "font-barlow-condensed"
//     ],
//     [
//         "Barlow Semi Condensed",
//         "font-barlow-semi-condensed"
//     ],
//     [
//         "Barriecito",
//         "font-barriecito"
//     ],
//     [
//         "Barrio",
//         "font-barrio"
//     ],
//     [
//         "Basic",
//         "font-basic"
//     ],
//     [
//         "Battambang",
//         "font-battambang"
//     ],
//     [
//         "Baumans",
//         "font-baumans"
//     ],
//     [
//         "Bayon",
//         "font-bayon"
//     ],
//     [
//         "Belgrano",
//         "font-belgrano"
//     ],
//     [
//         "Bellefair",
//         "font-bellefair"
//     ],
//     [
//         "Belleza",
//         "font-belleza"
//     ],
//     [
//         "BenchNine",
//         "font-benchnine"
//     ],
//     [
//         "Bentham",
//         "font-bentham"
//     ],
//     [
//         "Berkshire Swash",
//         "font-berkshire-swash"
//     ],
//     [
//         "Beth Ellen",
//         "font-beth-ellen"
//     ],
//     [
//         "Bevan",
//         "font-bevan"
//     ],
//     [
//         "Bhavuka",
//         "font-bhavuka"
//     ],
//     [
//         "Bigelow Rules",
//         "font-bigelow-rules"
//     ],
//     [
//         "Bigshot One",
//         "font-bigshot-one"
//     ],
//     [
//         "Bilbo",
//         "font-bilbo"
//     ],
//     [
//         "Bilbo Swash Caps",
//         "font-bilbo-swash-caps"
//     ],
//     [
//         "Bio Rhyme",
//         "font-bio-rhyme"
//     ],
//     [
//         "Bio Rhyme Expanded",
//         "font-bio-rhyme-expanded"
//     ],
//     [
//         "Biryani",
//         "font-biryani"
//     ],
//     [
//         "Bitter",
//         "font-bitter"
//     ],
//     [
//         "Black Han Sans",
//         "font-black-han-sans"
//     ],
//     [
//         "Black Ops One",
//         "font-black-ops-one"
//     ],
//     [
//         "Bonbon",
//         "font-bonbon"
//     ],
//     [
//         "Bowlby One",
//         "font-bowlby-one"
//     ],
//     [
//         "Bowlby One SC",
//         "font-bowlby-one-sc"
//     ],
//     [
//         "Brawler",
//         "font-brawler"
//     ],
//     [
//         "Bruno Ace",
//         "font-bruno-ace"
//     ],
//     [
//         "Bruno Ace SC",
//         "font-bruno-ace-sc"
//     ],
//     [
//         "Bubbler One",
//         "font-bubbler-one"
//     ],
//     [
//         "Buda",
//         "font-buda"
//     ],
//     [
//         "Buenard",
//         "font-buenard"
//     ],
//     [
//         "Bungee",
//         "font-bungee"
//     ],
//     [
//         "Bungee Hairline",
//         "font-bungee-hairline"
//     ],
//     [
//         "Bungee Inline",
//         "font-bungee-inline"
//     ],
//     [
//         "Bungee Outline",
//         "font-bungee-outline"
//     ],
//     [
//         "Bungee Shade",
//         "font-bungee-shade"
//     ],
//     [
//         "Butcherman",
//         "font-butcherman"
//     ],
//     [
//         "Butcherman Caps",
//         "font-butcherman-caps"
//     ],
//     [
//         "Butterfly Kids",
//         "font-butterfly-kids"
//     ],
//     [
//         "Cabin Sketch",
//         "font-cabin-sketch"
//     ],
//     [
//         "cabinvfbeta",
//         "font-cabinvfbeta"
//     ],
//     [
//         "Caesar Dressing",
//         "font-caesar-dressing"
//     ],
//     [
//         "Cairo",
//         "font-cairo"
//     ],
//     [
//         "Calligraffitti",
//         "font-calligraffitti"
//     ],
//     [
//         "Cambay",
//         "font-cambay"
//     ],
//     [
//         "Cambo",
//         "font-cambo"
//     ],
//     [
//         "Candal",
//         "font-candal"
//     ],
//     // [
//     //     "Cantarell",
//     //     "font-cantarell"
//     // ],
//     [
//         "Cantata One",
//         "font-cantata-one"
//     ],
//     [
//         "Capriola",
//         "font-capriola"
//     ],
//     [
//         "Cardo",
//         "font-cardo"
//     ],
//     [
//         "Carme",
//         "font-carme"
//     ],
//     [
//         "Carrois Gothic",
//         "font-carrois-gothic"
//     ],
//     [
//         "Carrois Gothic SC",
//         "font-carrois-gothic-sc"
//     ],
//     [
//         "Catamaran",
//         "font-catamaran"
//     ],
//     [
//         "Caudex",
//         "font-caudex"
//     ],
//     [
//         "Caveat Brush",
//         "font-caveat-brush"
//     ],
//     [
//         "Cedarville Cursive",
//         "font-cedarville-cursive"
//     ],
//     [
//         "Ceviche One",
//         "font-ceviche-one"
//     ],
//     [
//         "Chakra Petch",
//         "font-chakra-petch"
//     ],
//     [
//         "Changa",
//         "font-changa"
//     ],
//     [
//         "Changa One",
//         "font-changa-one"
//     ],
//     [
//         "Chango",
//         "font-chango"
//     ],
//     [
//         "Charm",
//         "font-charm"
//     ],
//     [
//         "Charmonman",
//         "font-charmonman"
//     ],
//     [
//         "Chau Philomene One",
//         "font-chau-philomene-one"
//     ],
//     [
//         "Chela One",
//         "font-chela-one"
//     ],
//     [
//         "Chelsea Market",
//         "font-chelsea-market"
//     ],
//     [
//         "Chenla",
//         "font-chenla"
//     ],
//     [
//         "Cherry Cream Soda",
//         "font-cherry-cream-soda"
//     ],
//     [
//         "Chewy",
//         "font-chewy"
//     ],
//     [
//         "Chicle",
//         "font-chicle"
//     ],
//     [
//         "Chilanka",
//         "font-chilanka"
//     ],
//     [
//         "Chivo",
//         "font-chivo"
//     ],
//     [
//         "Chonburi",
//         "font-chonburi"
//     ],
//     [
//         "Cinzel",
//         "font-cinzel"
//     ],
//     [
//         "Clicker Script",
//         "font-clicker-script"
//     ],
//     [
//         "Coda",
//         "font-coda"
//     ],
//     [
//         "Coda Caption",
//         "font-coda-caption"
//     ],
//     [
//         "Codystar",
//         "font-codystar"
//     ],
//     [
//         "Combo",
//         "font-combo"
//     ],
//     [
//         "Coming Soon",
//         "font-coming-soon"
//     ],
//     [
//         "Concert One",
//         "font-concert-one"
//     ],
//     [
//         "Condiment",
//         "font-condiment"
//     ],
//     [
//         "Content",
//         "font-content"
//     ],
//     [
//         "Contrail One",
//         "font-contrail-one"
//     ],
//     [
//         "Cookie",
//         "font-cookie"
//     ],
//     [
//         "Copse",
//         "font-copse"
//     ],
//     [
//         "Corben",
//         "font-corben"
//     ],
//     [
//         "Cormorant",
//         "font-cormorant"
//     ],
//     [
//         "Cormorant Garamond",
//         "font-cormorant-garamond"
//     ],
//     [
//         "Cormorant Infant",
//         "font-cormorant-infant"
//     ],
//     [
//         "Cormorant SC",
//         "font-cormorant-sc"
//     ],
//     [
//         "Courgette",
//         "font-courgette"
//     ],
//     [
//         "Cousine",
//         "font-cousine"
//     ],
//     [
//         "Covered By Your Grace",
//         "font-covered-by-your-grace"
//     ],
//     [
//         "Crafty Girls",
//         "font-crafty-girls"
//     ],
//     [
//         "Creepster Caps",
//         "font-creepster-caps"
//     ],
//     [
//         "Crete Round",
//         "font-crete-round"
//     ],
//     [
//         "Crimson Pro",
//         "font-crimson-pro"
//     ],
//     [
//         "Crimson Text",
//         "font-crimson-text"
//     ],
//     [
//         "Croissant One",
//         "font-croissant-one"
//     ],
//     [
//         "Crushed",
//         "font-crushed"
//     ],
//     [
//         "Cuprum",
//         "font-cuprum"
//     ],
//     [
//         "Cutive",
//         "font-cutive"
//     ],
//     [
//         "Cutive Mono",
//         "font-cutive-mono"
//     ],
//     [
//         "Damion",
//         "font-damion"
//     ],
//     [
//         "Dancing Script",
//         "font-dancing-script"
//     ],
//     [
//         "Dangrek",
//         "font-dangrek"
//     ],
//     [
//         "Darker Grotesque",
//         "font-darker-grotesque"
//     ],
//     [
//         "Dawning of a New Day",
//         "font-dawning-of-a-new-day"
//     ],
//     [
//         "Days One",
//         "font-days-one"
//     ],
//     [
//         "decovaralpha",
//         "font-decovaralpha"
//     ],
//     [
//         "Dekko",
//         "font-dekko"
//     ],
//     [
//         "Delius",
//         "font-delius"
//     ],
//     [
//         "Delius Swash Caps",
//         "font-delius-swash-caps"
//     ],
//     [
//         "Delius Unicase",
//         "font-delius-unicase"
//     ],
//     [
//         "Della Respira",
//         "font-della-respira"
//     ],
//     [
//         "Denk One",
//         "font-denk-one"
//     ],
//     [
//         "Devonshire",
//         "font-devonshire"
//     ],
//     [
//         "Dhurjati",
//         "font-dhurjati"
//     ],
//     [
//         "Dhyana",
//         "font-dhyana"
//     ],
//     [
//         "Digital Numbers",
//         "font-digital-numbers"
//     ],
//     [
//         "Diplomata",
//         "font-diplomata"
//     ],
//     [
//         "Diplomata SC",
//         "font-diplomata-sc"
//     ],
//     [
//         "DM Sans",
//         "font-dm-sans"
//     ],
//     [
//         "DM Serif Display",
//         "font-dm-serif-display"
//     ],
//     [
//         "Do Hyeon",
//         "font-do-hyeon"
//     ],
//     [
//         "Donegal One",
//         "font-donegal-one"
//     ],
//     [
//         "Doppio One",
//         "font-doppio-one"
//     ],
//     [
//         "Dorsa",
//         "font-dorsa"
//     ],
//     [
//         "Dosis",
//         "font-dosis"
//     ],
//     [
//         "Duru Sans",
//         "font-duru-sans"
//     ],
//     [
//         "Dynalight",
//         "font-dynalight"
//     ],
//     [
//         "East Sea Dokdo",
//         "font-east-sea-dokdo"
//     ],
//     [
//         "Eater Caps",
//         "font-eater-caps"
//     ],
//     [
//         "Eczar",
//         "font-eczar"
//     ],
//     [
//         "Ek Mukta",
//         "font-ek-mukta"
//     ],
//     [
//         "El Messiri",
//         "font-el-messiri"
//     ],
//     [
//         "Electrolize",
//         "font-electrolize"
//     ],
//     [
//         "Elsie",
//         "font-elsie"
//     ],
//     [
//         "Elsie Swash Caps",
//         "font-elsie-swash-caps"
//     ],
//     [
//         "Emilys Candy",
//         "font-emilys-candy"
//     ],
//     [
//         "Encode Sans Condensed",
//         "font-encode-sans-condensed"
//     ],
//     [
//         "Encode Sans Semi Condensed",
//         "font-encode-sans-semi-condensed"
//     ],
//     [
//         "Engagement",
//         "font-engagement"
//     ],
//     [
//         "Englebert",
//         "font-englebert"
//     ],
//     [
//         "Enriqueta",
//         "font-enriqueta"
//     ],
//     [
//         "Esteban",
//         "font-esteban"
//     ],
//     [
//         "Ewert",
//         "font-ewert"
//     ],
//     [
//         "Exo 2",
//         "font-exo-2"
//     ],
//     [
//         "Expletus Sans",
//         "font-expletus-sans"
//     ],
//     [
//         "Fahkwang",
//         "font-fahkwang"
//     ],
//     [
//         "Farro",
//         "font-farro"
//     ],
//     [
//         "Farsan",
//         "font-farsan"
//     ],
//     [
//         "Fascinate",
//         "font-fascinate"
//     ],
//     [
//         "Faster One",
//         "font-faster-one"
//     ],
//     [
//         "Fasthand",
//         "font-fasthand"
//     ],
//     [
//         "Fauna One",
//         "font-fauna-one"
//     ],
//     [
//         "Faustina",
//         "font-faustina"
//     ],
//     [
//         "faustinavfbeta",
//         "font-faustinavfbeta"
//     ],
//     [
//         "Federant",
//         "font-federant"
//     ],
//     [
//         "Federo",
//         "font-federo"
//     ],
//     [
//         "Fenix",
//         "font-fenix"
//     ],
//     [
//         "Fira Code",
//         "font-fira-code"
//     ],
//     [
//         "Fira Sans",
//         "font-fira-sans"
//     ],
//     [
//         "Fira Sans Extra Condensed",
//         "font-fira-sans-extra-condensed"
//     ],
//     [
//         "Fjord One",
//         "font-fjord-one"
//     ],
//     [
//         "Flavors",
//         "font-flavors"
//     ],
//     [
//         "Fondamento",
//         "font-fondamento"
//     ],
//     [
//         "Fontdiner Swanky",
//         "font-fontdiner-swanky"
//     ],
//     [
//         "Francois One",
//         "font-francois-one"
//     ],
//     [
//         "Freckle Face",
//         "font-freckle-face"
//     ],
//     [
//         "Fredoka One",
//         "font-fredoka-one"
//     ],
//     [
//         "Fresca",
//         "font-fresca"
//     ],
//     [
//         "Fruktur",
//         "font-fruktur"
//     ],
//     [
//         "Gabriela",
//         "font-gabriela"
//     ],
//     [
//         "Gafata",
//         "font-gafata"
//     ],
//     [
//         "Galada",
//         "font-galada"
//     ],
//     [
//         "Galdeano",
//         "font-galdeano"
//     ],
//     [
//         "Gayathri",
//         "font-gayathri"
//     ],
//     [
//         "Gemunu Libre",
//         "font-gemunu-libre"
//     ],
//     [
//         "Gentium Book Basic",
//         "font-gentium-book-basic"
//     ],
//     [
//         "Geostar",
//         "font-geostar"
//     ],
//     [
//         "Germania One",
//         "font-germania-one"
//     ],
//     [
//         "Gilda Display",
//         "font-gilda-display"
//     ],
//     [
//         "Glass Antiqua",
//         "font-glass-antiqua"
//     ],
//     [
//         "Gochi Hand",
//         "font-gochi-hand"
//     ],
//     [
//         "Gothic A1",
//         "font-gothic-a1"
//     ],
//     [
//         "Goudy Bookletter 1911",
//         "font-goudy-bookletter-1911"
//     ],
//     [
//         "Graduate",
//         "font-graduate"
//     ],
//     [
//         "Gravitas One",
//         "font-gravitas-one"
//     ],
//     [
//         "Great Vibes",
//         "font-great-vibes"
//     ],
//     [
//         "Grenze",
//         "font-grenze"
//     ],
//     [
//         "Gruppo",
//         "font-gruppo"
//     ],
//     [
//         "Gudea",
//         "font-gudea"
//     ],
//     [
//         "Gugi",
//         "font-gugi"
//     ],
//     [
//         "Gurajada",
//         "font-gurajada"
//     ],
//     [
//         "Habibi",
//         "font-habibi"
//     ],
//     [
//         "Hammersmith One",
//         "font-hammersmith-one"
//     ],
//     [
//         "Hanalei Fill",
//         "font-hanalei-fill"
//     ],
//     [
//         "Handlee",
//         "font-handlee"
//     ],
//     [
//         "hanna",
//         "font-hanna"
//     ],
//     [
//         "Harmattan",
//         "font-harmattan"
//     ],
//     [
//         "Heebo",
//         "font-heebo"
//     ],
//     [
//         "Hermeneus One",
//         "font-hermeneus-one"
//     ],
//     [
//         "Hind",
//         "font-hind"
//     ],
//     [
//         "Hind Colombo",
//         "font-hind-colombo"
//     ],
//     [
//         "Hind Guntur",
//         "font-hind-guntur"
//     ],
//     [
//         "Hind Jalandhar",
//         "font-hind-jalandhar"
//     ],
//     [
//         "Hind Madurai",
//         "font-hind-madurai"
//     ],
//     [
//         "Hind Siliguri",
//         "font-hind-siliguri"
//     ],
//     [
//         "Holtwood One SC",
//         "font-holtwood-one-sc"
//     ],
//     [
//         "Homenaje",
//         "font-homenaje"
//     ],
//     [
//         "IBM Plex Sans",
//         "font-ibm-plex-sans"
//     ],
//     [
//         "IBM Plex Sans Condensed",
//         "font-ibm-plex-sans-condensed"
//     ],
//     [
//         "IBM Plex Serif",
//         "font-ibm-plex-serif"
//     ],
//     [
//         "Iceberg",
//         "font-iceberg"
//     ],
//     [
//         "Iceland",
//         "font-iceland"
//     ],
//     [
//         "IM Fell Double Pica",
//         "font-im-fell-double-pica"
//     ],
//     [
//         "IM Fell DW Pica SC",
//         "font-im-fell-dw-pica-sc"
//     ],
//     [
//         "IM Fell English",
//         "font-im-fell-english"
//     ],
//     [
//         "IM Fell French Canon",
//         "font-im-fell-french-canon"
//     ],
//     [
//         "IM Fell French Canon SC",
//         "font-im-fell-french-canon-sc"
//     ],
//     [
//         "IM Fell Great Primer",
//         "font-im-fell-great-primer"
//     ],
//     [
//         "Inconsolata",
//         "font-inconsolata"
//     ],
//     [
//         "Inder",
//         "font-inder"
//     ],
//     [
//         "Indie Flower",
//         "font-indie-flower"
//     ],
//     [
//         "Inika",
//         "font-inika"
//     ],
//     [
//         "Inknut Antiqua",
//         "font-inknut-antiqua"
//     ],
//     [
//         "Irish Grover",
//         "font-irish-grover"
//     ],
//     [
//         "Istok Web",
//         "font-istok-web"
//     ],
//     [
//         "Italiana",
//         "font-italiana"
//     ],
//     [
//         "Italianno",
//         "font-italianno"
//     ],
//     [
//         "Itim",
//         "font-itim"
//     ],
//     [
//         "Jacques Francois",
//         "font-jacques-francois"
//     ],
//     [
//         "Jacques Francois Shadow",
//         "font-jacques-francois-shadow"
//     ],
//     [
//         "Jaldi",
//         "font-jaldi"
//     ],
//     [
//         "Jim Nightshade",
//         "font-jim-nightshade"
//     ],
//     [
//         "Jolly Lodger",
//         "font-jolly-lodger"
//     ],
//     [
//         "Jomhuria",
//         "font-jomhuria"
//     ],
//     [
//         "jomolhari",
//         "font-jomolhari"
//     ],
//     [
//         "Josefin Sans",
//         "font-josefin-sans"
//     ],
//     [
//         "Josefin Sans Std Light",
//         "font-josefin-sans-std-light"
//     ],
//     [
//         "Josefin Slab",
//         "font-josefin-slab"
//     ],
//     [
//         "Joti One",
//         "font-joti-one"
//     ],
//     [
//         "Jua",
//         "font-jua"
//     ],
//     [
//         "Judson",
//         "font-judson"
//     ],
//     [
//         "Junge",
//         "font-junge"
//     ],
//     [
//         "Just Another Hand",
//         "font-just-another-hand"
//     ],
//     [
//         "Just Me Again Down Here",
//         "font-just-me-again-down-here"
//     ],
//     [
//         "K2D",
//         "font-k2d"
//     ],
//     [
//         "Kadwa",
//         "font-kadwa"
//     ],
//     [
//         "Kameron",
//         "font-kameron"
//     ],
//     [
//         "Kantumruy",
//         "font-kantumruy"
//     ],
//     [
//         "Karla",
//         "font-karla"
//     ],
//     [
//         "Karla Tamil Inclined",
//         "font-karla-tamil-inclined"
//     ],
//     [
//         "Kaushan Script",
//         "font-kaushan-script"
//     ],
//     [
//         "Kavivanar",
//         "font-kavivanar"
//     ],
//     [
//         "Kavoon",
//         "font-kavoon"
//     ],
//     [
//         "Kdam Thmor",
//         "font-kdam-thmor"
//     ],
//     [
//         "Keania One",
//         "font-keania-one"
//     ],
//     [
//         "Kelly Slab",
//         "font-kelly-slab"
//     ],
//     [
//         "Kenia",
//         "font-kenia"
//     ],
//     [
//         "Khand",
//         "font-khand"
//     ],
//     [
//         "Khmer",
//         "font-khmer"
//     ],
//     [
//         "khyay",
//         "font-khyay"
//     ],
//     [
//         "Kite One",
//         "font-kite-one"
//     ],
//     [
//         "Knewave",
//         "font-knewave"
//     ],
//     [
//         "Kodchasan",
//         "font-kodchasan"
//     ],
//     [
//         "kokoro",
//         "font-kokoro"
//     ],
//     [
//         "kopubbatang",
//         "font-kopubbatang"
//     ],
//     [
//         "Kotta One",
//         "font-kotta-one"
//     ],
//     [
//         "Koulen",
//         "font-koulen"
//     ],
//     [
//         "Kranky",
//         "font-kranky"
//     ],
//     [
//         "Kreon",
//         "font-kreon"
//     ],
//     [
//         "Kristi",
//         "font-kristi"
//     ],
//     [
//         "Krub",
//         "font-krub"
//     ],
//     [
//         "Kurale",
//         "font-kurale"
//     ],
//     [
//         "La Belle Aurore",
//         "font-la-belle-aurore"
//     ],
//     [
//         "Lacquer",
//         "font-lacquer"
//     ],
//     [
//         "Laila",
//         "font-laila"
//     ],
//     [
//         "Lancelot",
//         "font-lancelot"
//     ],
//     [
//         "laomuangdon",
//         "font-laomuangdon"
//     ],
//     [
//         "Lateef",
//         "font-lateef"
//     ],
//     // [
//     //     "Lato",
//     //     "font-lato"
//     // ],
//     [
//         "League Script",
//         "font-league-script"
//     ],
//     [
//         "Ledger",
//         "font-ledger"
//     ],
//     [
//         "Lekton",
//         "font-lekton"
//     ],
//     [
//         "Lemonada",
//         "font-lemonada"
//     ],
//     [
//         "Libre Barcode 128",
//         "font-libre-barcode-128"
//     ],
//     [
//         "Libre Barcode 128 Text",
//         "font-libre-barcode-128-text"
//     ],
//     [
//         "Libre Barcode 39",
//         "font-libre-barcode-39"
//     ],
//     [
//         "Libre Barcode 39 Extended",
//         "font-libre-barcode-39-extended"
//     ],
//     [
//         "Libre Barcode 39 Extended Text",
//         "font-libre-barcode-39-extended-text"
//     ],
//     [
//         "Libre Barcode 39 Text",
//         "font-libre-barcode-39-text"
//     ],
//     [
//         "Libre Baskerville",
//         "font-libre-baskerville"
//     ],
//     [
//         "Libre Caslon Display",
//         "font-libre-caslon-display"
//     ],
//     [
//         "Libre Caslon Text",
//         "font-libre-caslon-text"
//     ],
//     [
//         "Libre Franklin",
//         "font-libre-franklin"
//     ],
//     [
//         "Life Savers",
//         "font-life-savers"
//     ],
//     [
//         "Lily Script One",
//         "font-lily-script-one"
//     ],
//     [
//         "Linden Hill",
//         "font-linden-hill"
//     ],
//     [
//         "LiuJianMaoCao",
//         "font-liujianmaocao"
//     ],
//     [
//         "Livvic",
//         "font-livvic"
//     ],
//     [
//         "Lobster Two",
//         "font-lobster-two"
//     ],
//     [
//         "Lohit Bengali",
//         "font-lohit-bengali"
//     ],
//     [
//         "Lohit Tamil",
//         "font-lohit-tamil"
//     ],
//     [
//         "lohitdevanagari",
//         "font-lohitdevanagari"
//     ],
//     [
//         "Londrina Sketch",
//         "font-londrina-sketch"
//     ],
//     [
//         "LongCang",
//         "font-longcang"
//     ],
//     [
//         "Lora",
//         "font-lora"
//     ],
//     [
//         "Loved by the King",
//         "font-loved-by-the-king"
//     ],
//     [
//         "Lovers Quarrel",
//         "font-lovers-quarrel"
//     ],
//     [
//         "Luckiest Guy",
//         "font-luckiest-guy"
//     ],
//     [
//         "Lustria",
//         "font-lustria"
//     ],
//     [
//         "Macondo",
//         "font-macondo"
//     ],
//     [
//         "Macondo Swash Caps",
//         "font-macondo-swash-caps"
//     ],
//     [
//         "Mada",
//         "font-mada"
//     ],
//     [
//         "Magra",
//         "font-magra"
//     ],
//     [
//         "Maiden Orange",
//         "font-maiden-orange"
//     ],
//     [
//         "Mali",
//         "font-mali"
//     ],
//     [
//         "Marcellus SC",
//         "font-marcellus-sc"
//     ],
//     [
//         "Marck Script",
//         "font-marck-script"
//     ],
//     [
//         "Marmelad",
//         "font-marmelad"
//     ],
//     [
//         "Martel Sans",
//         "font-martel-sans"
//     ],
//     [
//         "MaShanZheng",
//         "font-mashanzheng"
//     ],
//     [
//         "Mate SC",
//         "font-mate-sc"
//     ],
//     [
//         "mavenprovfbeta",
//         "font-mavenprovfbeta"
//     ],
//     [
//         "Meddon",
//         "font-meddon"
//     ],
//     [
//         "Medula One",
//         "font-medula-one"
//     ],
//     [
//         "Megrim",
//         "font-megrim"
//     ],
//     [
//         "Merge One",
//         "font-merge-one"
//     ],
//     [
//         "Merienda One",
//         "font-merienda-one"
//     ],
//     [
//         "Merriweather",
//         "font-merriweather"
//     ],
//     [
//         "Merriweather Sans",
//         "font-merriweather-sans"
//     ],
//     [
//         "Mervale Script",
//         "font-mervale-script"
//     ],
//     [
//         "Metrophobic",
//         "font-metrophobic"
//     ],
//     [
//         "Miama",
//         "font-miama"
//     ],
//     [
//         "Michroma",
//         "font-michroma"
//     ],
//     [
//         "Milonga",
//         "font-milonga"
//     ],
//     [
//         "Miltonian",
//         "font-miltonian"
//     ],
//     [
//         "Miltonian Tattoo",
//         "font-miltonian-tattoo"
//     ],
//     [
//         "Mina",
//         "font-mina"
//     ],
//     [
//         "Miniver",
//         "font-miniver"
//     ],
//     [
//         "Miriam Libre",
//         "font-miriam-libre"
//     ],
//     [
//         "Miss Fajardose",
//         "font-miss-fajardose"
//     ],
//     [
//         "Modak",
//         "font-modak"
//     ],
//     [
//         "Modern Antiqua",
//         "font-modern-antiqua"
//     ],
//     [
//         "Molengo",
//         "font-molengo"
//     ],
//     [
//         "Molle",
//         "font-molle"
//     ],
//     [
//         "Monda",
//         "font-monda"
//     ],
//     [
//         "Monofett",
//         "font-monofett"
//     ],
//     [
//         "Monoton",
//         "font-monoton"
//     ],
//     [
//         "Monsieur La Doulaise",
//         "font-monsieur-la-doulaise"
//     ],
//     [
//         "Montez",
//         "font-montez"
//     ],
//     // [
//     //     "Montserrat",
//     //     "font-montserrat"
//     // ],
//     [
//         "Montserrat Alternates",
//         "font-montserrat-alternates"
//     ],
//     [
//         "Montserrat Subrayada",
//         "font-montserrat-subrayada"
//     ],
//     [
//         "Moul",
//         "font-moul"
//     ],
//     [
//         "Moulpali",
//         "font-moulpali"
//     ],
//     [
//         "Mountains of Christmas",
//         "font-mountains-of-christmas"
//     ],
//     [
//         "Mouse Memoirs",
//         "font-mouse-memoirs"
//     ],
//     [
//         "mplus1p",
//         "font-mplus1p"
//     ],
//     [
//         "Mr Bedford",
//         "font-mr-bedford"
//     ],
//     [
//         "Mr Bedfort",
//         "font-mr-bedfort"
//     ],
//     [
//         "Mr Dafoe",
//         "font-mr-dafoe"
//     ],
//     [
//         "Mr De Haviland",
//         "font-mr-de-haviland"
//     ],
//     [
//         "Mrs Saint Delafield",
//         "font-mrs-saint-delafield"
//     ],
//     [
//         "Mrs Sheppards",
//         "font-mrs-sheppards"
//     ],
//     [
//         "Mukta",
//         "font-mukta"
//     ],
//     [
//         "Mukta Mahee",
//         "font-mukta-mahee"
//     ],
//     [
//         "Mukta Vaani",
//         "font-mukta-vaani"
//     ],
//     [
//         "myanmarsanspro",
//         "font-myanmarsanspro"
//     ],
//     [
//         "NATS",
//         "font-nats"
//     ],
//     [
//         "Neuton",
//         "font-neuton"
//     ],
//     [
//         "New Rocker",
//         "font-new-rocker"
//     ],
//     [
//         "News Cycle",
//         "font-news-cycle"
//     ],
//     [
//         "nicomoji",
//         "font-nicomoji"
//     ],
//     [
//         "Niconne",
//         "font-niconne"
//     ],
//     [
//         "nikukyu",
//         "font-nikukyu"
//     ],
//     [
//         "Niramit",
//         "font-niramit"
//     ],
//     [
//         "Nobile",
//         "font-nobile"
//     ],
//     [
//         "Norican",
//         "font-norican"
//     ],
//     [
//         "Nosifer Caps",
//         "font-nosifer-caps"
//     ],
//     [
//         "Nothing You Could Do",
//         "font-nothing-you-could-do"
//     ],
//     [
//         "Noto Sans",
//         "font-noto-sans"
//     ],
//     [
//         "notosanstamil",
//         "font-notosanstamil"
//     ],
//     [
//         "Nova Cut",
//         "font-nova-cut"
//     ],
//     [
//         "Nova Flat",
//         "font-nova-flat"
//     ],
//     [
//         "Nova Mono",
//         "font-nova-mono"
//     ],
//     [
//         "Nova Slim",
//         "font-nova-slim"
//     ],
//     [
//         "NTR",
//         "font-ntr"
//     ],
//     [
//         "Numans",
//         "font-numans"
//     ],
//     [
//         "Nunito",
//         "font-nunito"
//     ],
//     [
//         "Nunito Sans",
//         "font-nunito-sans"
//     ],
//     [
//         "Odor Mean Chey",
//         "font-odor-mean-chey"
//     ],
//     [
//         "Offside",
//         "font-offside"
//     ],
//     [
//         "OFL Sorts Mill Goudy TT",
//         "font-ofl-sorts-mill-goudy-tt"
//     ],
//     [
//         "Old Standard TT",
//         "font-old-standard-tt"
//     ],
//     [
//         "Oldenburg",
//         "font-oldenburg"
//     ],
//     [
//         "Oleo Script",
//         "font-oleo-script"
//     ],
//     [
//         "Oleo Script Swash Caps",
//         "font-oleo-script-swash-caps"
//     ],
//     // [
//     //     "Open Sans",
//     //     "font-open-sans"
//     // ],
//     [
//         "Open Sans Condensed",
//         "font-open-sans-condensed"
//     ],
//     [
//         "opensanshebrew",
//         "font-opensanshebrew"
//     ],
//     [
//         "opensanshebrewcondensed",
//         "font-opensanshebrewcondensed"
//     ],
//     [
//         "Oranienbaum",
//         "font-oranienbaum"
//     ],
//     [
//         "Orbitron",
//         "font-orbitron"
//     ],
//     [
//         "Oregano",
//         "font-oregano"
//     ],
//     [
//         "Orienta",
//         "font-orienta"
//     ],
//     [
//         "Oswald",
//         "font-oswald"
//     ],
//     [
//         "Over the Rainbow",
//         "font-over-the-rainbow"
//     ],
//     [
//         "Overlock",
//         "font-overlock"
//     ],
//     [
//         "Overlock SC",
//         "font-overlock-sc"
//     ],
//     [
//         "Overpass",
//         "font-overpass"
//     ],
//     [
//         "Overpass Mono",
//         "font-overpass-mono"
//     ],
//     [
//         "Oxygen",
//         "font-oxygen"
//     ],
//     [
//         "Oxygen Mono",
//         "font-oxygen-mono"
//     ],
//     [
//         "Pacifico",
//         "font-pacifico"
//     ],
//     [
//         "Palanquin",
//         "font-palanquin"
//     ],
//     [
//         "Palanquin Dark",
//         "font-palanquin-dark"
//     ],
//     [
//         "Pangolin",
//         "font-pangolin"
//     ],
//     [
//         "Paprika",
//         "font-paprika"
//     ],
//     [
//         "Parisienne",
//         "font-parisienne"
//     ],
//     [
//         "Passion One",
//         "font-passion-one"
//     ],
//     [
//         "Pattaya",
//         "font-pattaya"
//     ],
//     [
//         "Patua One",
//         "font-patua-one"
//     ],
//     [
//         "Pavanam",
//         "font-pavanam"
//     ],
//     [
//         "Pecita",
//         "font-pecita"
//     ],
//     [
//         "Peralta",
//         "font-peralta"
//     ],
//     [
//         "Phetsarath",
//         "font-phetsarath"
//     ],
//     [
//         "Philosopher",
//         "font-philosopher"
//     ],
//     [
//         "Piedra",
//         "font-piedra"
//     ],
//     [
//         "Pirata One",
//         "font-pirata-one"
//     ],
//     [
//         "Playfair Display",
//         "font-playfair-display"
//     ],
//     [
//         "Poetsen One",
//         "font-poetsen-one"
//     ],
//     [
//         "Poiret One",
//         "font-poiret-one"
//     ],
//     [
//         "Poller One",
//         "font-poller-one"
//     ],
//     [
//         "Pontano Sans",
//         "font-pontano-sans"
//     ],
//     // [
//     //     "Poppins",
//     //     "font-poppins"
//     // ],
//     [
//         "Post No Bills Colombo",
//         "font-post-no-bills-colombo"
//     ],
//     [
//         "Pragati Narrow",
//         "font-pragati-narrow"
//     ],
//     [
//         "Press Start 2P",
//         "font-press-start-2p"
//     ],
//     [
//         "Proza Libre",
//         "font-proza-libre"
//     ],
//     [
//         "PT Sans",
//         "font-pt-sans"
//     ],
//     [
//         "PT Sans Caption",
//         "font-pt-sans-caption"
//     ],
//     [
//         "PT Sans Narrow",
//         "font-pt-sans-narrow"
//     ],
//     // [
//     //     "PT Serif",
//     //     "font-pt-serif"
//     // ],
//     [
//         "PT Serif Caption",
//         "font-pt-serif-caption"
//     ],
//     [
//         "Pushster",
//         "font-pushster"
//     ],
//     [
//         "Quando",
//         "font-quando"
//     ],
//     [
//         "Quattrocento",
//         "font-quattrocento"
//     ],
//     [
//         "Questrial",
//         "font-questrial"
//     ],
//     [
//         "Quicksand",
//         "font-quicksand"
//     ],
//     [
//         "Quintessential",
//         "font-quintessential"
//     ],
//     [
//         "Racing Sans One",
//         "font-racing-sans-one"
//     ],
//     [
//         "Rajdhani",
//         "font-rajdhani"
//     ],
//     [
//         "Raleway",
//         "font-raleway"
//     ],
//     [
//         "Ramabhadra",
//         "font-ramabhadra"
//     ],
//     [
//         "Rambla",
//         "font-rambla"
//     ],
//     [
//         "Ranchers",
//         "font-ranchers"
//     ],
//     [
//         "Red Hat Display",
//         "font-red-hat-display"
//     ],
//     [
//         "Redacted",
//         "font-redacted"
//     ],
//     [
//         "Redressed",
//         "font-redressed"
//     ],
//     [
//         "Reem Kufi",
//         "font-reem-kufi"
//     ],
//     [
//         "Ribeye Marrow",
//         "font-ribeye-marrow"
//     ],
//     [
//         "Risque",
//         "font-risque"
//     ],
//     [
//         "Roboto",
//         "font-roboto"
//     ],
//     [
//         "Roboto Condensed",
//         "font-roboto-condensed"
//     ],
//     [
//         "Roboto Mono",
//         "font-roboto-mono"
//     ],
//     [
//         "Roboto Slab",
//         "font-roboto-slab"
//     ],
//     [
//         "Rock Salt",
//         "font-rock-salt"
//     ],
//     [
//         "Rosario",
//         "font-rosario"
//     ],
//     [
//         "Rosarivo",
//         "font-rosarivo"
//     ],
//     [
//         "Rozha One",
//         "font-rozha-one"
//     ],
//     [
//         "Rubik",
//         "font-rubik"
//     ],
//     [
//         "Rubik Mono One",
//         "font-rubik-mono-one"
//     ],
//     [
//         "Rubik One",
//         "font-rubik-one"
//     ],
//     [
//         "Ruda",
//         "font-ruda"
//     ],
//     [
//         "Rum Raisin",
//         "font-rum-raisin"
//     ],
//     [
//         "Russo One",
//         "font-russo-one"
//     ],
//     [
//         "Rye",
//         "font-rye"
//     ],
//     [
//         "Sahitya",
//         "font-sahitya"
//     ],
//     [
//         "Sail",
//         "font-sail"
//     ],
//     [
//         "Saira",
//         "font-saira"
//     ],
//     [
//         "Saira Extra Condensed",
//         "font-saira-extra-condensed"
//     ],
//     [
//         "Saira Stencil",
//         "font-saira-stencil"
//     ],
//     [
//         "Saira Stencil One",
//         "font-saira-stencil-one"
//     ],
//     [
//         "Sancreek",
//         "font-sancreek"
//     ],
//     [
//         "Sansation",
//         "font-sansation"
//     ],
//     [
//         "Sansita",
//         "font-sansita"
//     ],
//     [
//         "Sansita One",
//         "font-sansita-one"
//     ],
//     [
//         "Sarabun",
//         "font-sarabun"
//     ],
//     [
//         "Sarina",
//         "font-sarina"
//     ],
//     [
//         "sawarabimincho",
//         "font-sawarabimincho"
//     ],
//     [
//         "Scheherazade",
//         "font-scheherazade"
//     ],
//     [
//         "Schoolbell",
//         "font-schoolbell"
//     ],
//     [
//         "Scope One",
//         "font-scope-one"
//     ],
//     [
//         "Secular One",
//         "font-secular-one"
//     ],
//     [
//         "Sedan SC",
//         "font-sedan-sc"
//     ],
//     [
//         "Sedgwick Ave",
//         "font-sedgwick-ave"
//     ],
//     [
//         "Sedgwick Ave Display",
//         "font-sedgwick-ave-display"
//     ],
//     [
//         "Seymour One",
//         "font-seymour-one"
//     ],
//     [
//         "Shadows Into Light",
//         "font-shadows-into-light"
//     ],
//     [
//         "Shanti",
//         "font-shanti"
//     ],
//     [
//         "Share Tech Mono",
//         "font-share-tech-mono"
//     ],
//     [
//         "Shojumaru",
//         "font-shojumaru"
//     ],
//     [
//         "Short Stack",
//         "font-short-stack"
//     ],
//     [
//         "Shrikhand",
//         "font-shrikhand"
//     ],
//     [
//         "Siemreap",
//         "font-siemreap"
//     ],
//     [
//         "Sigmar One",
//         "font-sigmar-one"
//     ],
//     [
//         "Signika",
//         "font-signika"
//     ],
//     [
//         "Sintony",
//         "font-sintony"
//     ],
//     [
//         "Sirin Stencil",
//         "font-sirin-stencil"
//     ],
//     [
//         "Sitara",
//         "font-sitara"
//     ],
//     [
//         "Skranji",
//         "font-skranji"
//     ],
//     [
//         "Slabo 13px",
//         "font-slabo-13px"
//     ],
//     [
//         "Slabo 27px",
//         "font-slabo-27px"
//     ],
//     [
//         "Smokum",
//         "font-smokum"
//     ],
//     [
//         "Snippet",
//         "font-snippet"
//     ],
//     [
//         "Sofia",
//         "font-sofia"
//     ],
//     [
//         "Solway",
//         "font-solway"
//     ],
//     [
//         "Song Myung",
//         "font-song-myung"
//     ],
//     [
//         "souliyo",
//         "font-souliyo"
//     ],
//     [
//         "Source Code Pro",
//         "font-source-code-pro"
//     ],
//     [
//         "Source Sans Pro",
//         "font-source-sans-pro"
//     ],
//     [
//         "Source Serif Pro",
//         "font-source-serif-pro"
//     ],
//     [
//         "Space Mono",
//         "font-space-mono"
//     ],
//     [
//         "Spicy Rice",
//         "font-spicy-rice"
//     ],
//     [
//         "Spirax",
//         "font-spirax"
//     ],
//     [
//         "Sriracha",
//         "font-sriracha"
//     ],
//     [
//         "Srisakdi",
//         "font-srisakdi"
//     ],
//     [
//         "Staatliches",
//         "font-staatliches"
//     ],
//     [
//         "Stalemate",
//         "font-stalemate"
//     ],
//     [
//         "Stalinist One",
//         "font-stalinist-one"
//     ],
//     [
//         "Stardos Stencil",
//         "font-stardos-stencil"
//     ],
//     [
//         "Stint Ultra Condensed",
//         "font-stint-ultra-condensed"
//     ],
//     [
//         "Strait",
//         "font-strait"
//     ],
//     [
//         "Strong",
//         "font-strong"
//     ],
//     [
//         "Sue Ellen Francisco",
//         "font-sue-ellen-francisco"
//     ],
//     [
//         "Sumana",
//         "font-sumana"
//     ],
//     [
//         "Sunflower",
//         "font-sunflower"
//     ],
//     [
//         "Sunshiney",
//         "font-sunshiney"
//     ],
//     [
//         "Suravaram",
//         "font-suravaram"
//     ],
//     [
//         "Swanky and Moo Moo",
//         "font-swanky-and-moo-moo"
//     ],
//     [
//         "Syncopate",
//         "font-syncopate"
//     ],
//     [
//         "Tajawal",
//         "font-tajawal"
//     ],
//     [
//         "Taprom",
//         "font-taprom"
//     ],
//     [
//         "Taviraj",
//         "font-taviraj"
//     ],
//     [
//         "Teko",
//         "font-teko"
//     ],
//     [
//         "Telex",
//         "font-telex"
//     ],
//     [
//         "Terminal Dosis Light",
//         "font-terminal-dosis-light"
//     ],
//     [
//         "Thabit",
//         "font-thabit"
//     ],
//     [
//         "Thasadith",
//         "font-thasadith"
//     ],
//     [
//         "Tienne",
//         "font-tienne"
//     ],
//     [
//         "Timmana",
//         "font-timmana"
//     ],
//     [
//         "Tinos",
//         "font-tinos"
//     ],
//     [
//         "Titillium Web",
//         "font-titillium-web"
//     ],
//     [
//         "Trade Winds",
//         "font-trade-winds"
//     ],
//     [
//         "Trocchi",
//         "font-trocchi"
//     ],
//     [
//         "Trykker",
//         "font-trykker"
//     ],
//     // [
//     //     "Ubuntu",
//     //     "font-ubuntu"
//     // ],
//     [
//         "Ultra",
//         "font-ultra"
//     ],
//     [
//         "Underdog",
//         "font-underdog"
//     ],
//     [
//         "UnifrakturCook",
//         "font-unifrakturcook"
//     ],
//     [
//         "Unkempt",
//         "font-unkempt"
//     ],
//     [
//         "Unna",
//         "font-unna"
//     ],
//     [
//         "Varela",
//         "font-varela"
//     ],
//     [
//         "Varela Round",
//         "font-varela-round"
//     ],
//     [
//         "Vibur",
//         "font-vibur"
//     ],
//     [
//         "Vidaloka",
//         "font-vidaloka"
//     ],
//     [
//         "Voces",
//         "font-voces"
//     ],
//     [
//         "Volkhov",
//         "font-volkhov"
//     ],
//     [
//         "Vollkorn",
//         "font-vollkorn"
//     ],
//     [
//         "Voltaire",
//         "font-voltaire"
//     ],
//     [
//         "Walter Turncoat",
//         "font-walter-turncoat"
//     ],
//     [
//         "Wellfleet",
//         "font-wellfleet"
//     ],
//     [
//         "Wire One",
//         "font-wire-one"
//     ],
//     [
//         "Yaldevi Colombo",
//         "font-yaldevi-colombo"
//     ],
//     [
//         "Yantramanav",
//         "font-yantramanav"
//     ],
//     [
//         "Yellowtail",
//         "font-yellowtail"
//     ],
//     [
//         "Yeseva One",
//         "font-yeseva-one"
//     ],
//     [
//         "Yinmar",
//         "font-yinmar"
//     ],
//     [
//         "ZhiMangXing",
//         "font-zhimangxing"
//     ]
// ]


// const fontInfoFetch = fetch('https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyCwo7PJogsP2O0CRqbds2PyPvw_LXodKuM')
//     .then(res => res.json())
//     .then((out) => {
//         console.log(out);
//         return out.items
// }).catch(err => console.error(err));

